export default __webpack_public_path__ + "static/media/XSGD.36dd6b5a.png";